var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeekLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 172,
    viewBox: "0 0 99 172",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.6086 53.8491V0.264893C44.2864 0.264893 0.0927817 44.334 0.0927817 98.5033H32.4297C22.2427 107.696 14.1017 118.916 8.53182 131.44C2.96199 143.964 0.0871438 157.513 0.0927817 171.213H53.8283C53.8419 159.374 58.5641 148.024 66.9591 139.653C75.3542 131.282 86.7363 126.573 98.6086 126.56V72.9746C84.1985 72.9635 69.9636 76.1248 56.9201 82.2326C60.2085 73.8752 65.9435 66.6982 73.3789 61.6359C80.8142 56.5736 89.6055 53.8603 98.6086 53.8491Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeekLogo);
export default __webpack_public_path__ + "static/media/FeekLogo.c2cc362f833f494c843b5a8b92956f71.svg";
export { ForwardRef as ReactComponent };